import axios from "axios";
import { useQuery } from "react-query";
import { API_ENDPOINT } from "../utils/constants";
import { getHeader } from "../utils/utils2";

const useAdminEventSettings = () => {
  return useQuery({
    queryKey: ["get-event-settings-mini"],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}/admin/get-event-settings-mini`,
        getHeader() // Assuming this returns { headers: { ... } }
      );
      return response.data;
    },

    // Performance: Don't refetch automatically for at least 5 minutes
    staleTime: 1000 * 60 * 5,

    retry: (failureCount, error) => {
      // 1. Cap retries to prevent infinite loops (e.g., max 3 retries)
      if (failureCount >= 3) return false;

      // 2. Retry on pure network errors (up to the cap)
      if (!error.response) return true;

      // 3. Prevent retries on specific HTTP status codes
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500;
    },
  });
};

export default useAdminEventSettings;
